module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAATlBMVEUAAADLuOnLuOnLuOmaqrTLuOnLuOnLuOmyp8/FtOK/sNyNjqdndX+GiqC4q9Wmn8GTkq16gpOAhppteYaZl7R0fYyfm7uso8iaqrSaqrR5mz4hAAAAGnRSTlMAcO///wBg3/////////////////////9AAP5QBD8AAADpSURBVHgB7ddPb4MwDEDxUI8S4K1Awp/2+3/RbT14CNFNcnLYpLxT5MNPkW92pVLp56qLnPd2kpx3qWpXiSRA2tU18p3/rLVBjdNn1/Ps/WaBRKEBbTRD6kwhAvR2qI3A/LUfPwGzGRqAQU1ia4VmWPbb8glQ0NmSAK2Azm79Klao0x1pNkgCLFkgDwzJ0MSuLQFiX0iAQq4fPYswi5YAhT8HRVhzQB7ockAT9JIB6iF2GaAB2CQd2jg0G6HAMSM0cmg0QOf9X6hABSpQgZo8UOOuuY6aOteZVb/sftLjZe6RXoF+r0AF+gBm4I7YF7mYZQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f4b7.png
// module id = 1006
// module chunks = 0